import script from "./Messages.vue?vue&type=script&setup=true&lang=ts"
export * from "./Messages.vue?vue&type=script&setup=true&lang=ts"

export default script